import { Field, ID, Int, ObjectType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { MilkPickupRouteDetailRef } from './MilkPickupRouteDetailRef'

@ObjectType()
export class MilkPickupRouteRef {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  remarks?: string

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number })
  distance?: number

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  status?: string

  @Field(() => [MilkPickupRouteDetailRef], { nullable: true })
  @Prop({ type: [MilkPickupRouteDetailRef] }, PropType.ARRAY)
  details?: ReturnType<() => MilkPickupRouteDetailRef[]>
}
